import { render } from "./info.vue?vue&type=template&id=51f20da5&scoped=true"
const script = {}

import "./info.vue?vue&type=style&index=0&id=51f20da5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f20da5"]])

export default __exports__